import React from "react";

import Login from "./Login";

const Settings = () => {
	return <Login />;
};

export default Settings;
